export function getCheckedLayersKeyFromSession(projectId: string) {
  return `project-layers::${projectId}`;
}
